import { createTheme, alpha } from "@mui/material";
import { deepmerge } from "@mui/utils";
import baseThemeOptions from "./baseThemeOptions";

const colorSet = {
  primaryMain: "#3c3c7d",
  primaryLight: "#0071B2",
  secondary: "#363657",
  defaultTextColor: "#303030",
};

// Themes for different URLs
const themeTraining = createTheme(
  deepmerge(baseThemeOptions, {
    palette: {
      primary: {
        main: colorSet.primaryMain,
      },

      secondary: {
        main: colorSet.secondary,
      },

      widgetStyles: {
        minimizedChatBubble: {
          backgroundColor: colorSet.primaryMain,
          iconColor: "#FFF",
          hoverColor: colorSet.secondary,
        },

        navbar: {
          backgroundColor: colorSet.primaryLight,
          textColor: "#FFF",
          chevronColor: "#FFF",
          chevronHoverColor: alpha(colorSet.secondary, 0.2),
        },

        welcomePage: {
          backgroundColor: colorSet.primaryLight,
          textColor: "#FFF",
          linkColor: "#FFF",
          linkHoverColor: "#D1FFFA",
        },

        dataProtectionPage: {
          backgroundColor: "#FFF",
          headlineColor: colorSet.primaryLight,
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.primaryMain,
          linkHoverColor: colorSet.primaryLight,
        },

        button: {
          primary: {
            backgroundColor: colorSet.primaryMain,
            textColor: "#FFF",
            hoverColor: colorSet.defaultTextColor,
          },
          secondary: {
            backgroundColor: colorSet.secondary,
            textColor: colorSet.primaryMain,
            hoverColor: colorSet.secondary,
          },
        },

        userChatBubble: {
          background: alpha(colorSet.primaryLight, 0.2),
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.primaryMain,
          linkHoverColor: colorSet.primaryLight,
        },

        botChatBubble: {
          background: alpha(colorSet.defaultTextColor, 0.1),
          textColor: colorSet.defaultTextColor,
          linkColor: colorSet.primaryMain,
          linkHoverColor: colorSet.primaryLight,
        },

        chatControls: {
          backgroundColor: "#FFF",
          iconColor: "#637286",
          iconHoverColor: colorSet.primaryLight,
        },
      },
    },
  })
);

export default themeTraining;
